import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { renderTypographyStyles } from '../../../../../base/utils';

export const StyledNavButtons = styled('div')(
  ({ theme }) => `
     display: flex;
     flex-wrap: wrap;
     gap:  ${theme.DS_spacing(['xs'])};
     padding: ${theme.DS_spacing(['xxs'])} 0;
     a:first-of-type {
      min-width: unset;
      padding: ${theme.DS_spacing(['xxs'])} ${theme.DS_spacing(['md'])};
     }
     a:last-of-type {
      min-width: 210px;
      padding: ${theme.DS_spacing(['xxs'])} ${theme.DS_spacing(['xl'])};
     }
     
    ${theme.breakpoints.up('md')} {
      flex-wrap: nowrap;
        a {
          min-height: unset;
          max-height: 48px;
        }     
      }
      ${theme.breakpoints.up('lg')} {
         align-self: start;    
        a {
         &:first-of-type {
           @media (min-width: 1280px) and (max-width: 1400px) {
                max-width: 125px;
        }
         }
         span {
            overflow: hidden;
              span {
              text-overflow: ellipsis;
               overflow: hidden;
               white-space: nowrap;
              }
            }
         }
    }
  `,
);

export const StyledIconLinks = styled('div')(
  ({ theme }) => `
     display: flex;
     flex-direction:column;
     gap:  12px;

     a{
       color: ${theme.DS_palette.text.primary};
       display: flex;
       flex-direction:row;
       margin:  ${theme.DS_spacing(['xxxs'])} 0;
       ${renderTypographyStyles(theme.typography.DS_copyMediumBold)};
       
       span {
        margin-left:  ${theme.DS_spacing(['xs'])};
       }
     }
     svg {
      fill: none;
     }
      ${theme.breakpoints.up('lg')} {
       flex-direction:row;
       gap:  0;
   
       a {
         padding:  16px 12px 12px;
         span{
           display: none;
         }
       }
        a:hover {
         svg > path{
           stroke: ${theme.DS_palette.buttons.enabled};
         }
       }
       
       a:first-of-type {
        order: 2;
       }
      
      }
     
  `,
);
export const StyledMobileBoxDrawer = styled(Box)(
  ({ theme }) => `
   padding-top: ${theme.DS_spacing(['xl'])}; 
  `,
);

export const StyledWrapperMobileVisibleOnly = styled('div')(
  ({ theme }) => `
      ${theme.breakpoints.up('md')} {
      display: none;
      } 
  `,
);
